import React, { Component } from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Select } from 'antd';
import { Toggle } from 'redux-form-material-ui';
import { List, AutoSizer } from 'react-virtualized';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { CSSTransitionGroup } from 'react-transition-group';

import { TextField } from 'redux-form-material-ui';
import { Card, CardText } from 'material-ui/Card';
import TransactionCard from '@material-ui/core/Card';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdDragHandle as DragIcon } from 'react-icons/md';

import Header from 'components/shared/Header';

import { currencyMask } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { required } from 'helpers/Validator';
import { RenderError } from 'components/shared/RenderError';

import validate from './validate';

const styles = {
  transactionCard: {
    background: colors.LIGHTEST_GRAY,
    width: '99%',
    marginLeft: '1px',
    marginBottom: '25px',
  },
  itemCard: {
    borderRadius: '8px',
    margin: '0 auto 10px',
  },
  deleteRoomButton: {
    verticalAlign: 'top',
    paddingLeft: '0',
    width: '30px',
  },
  labelText: {
    fontSize: 11,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
};

class InspectionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      field_type: props.fields.get(props.index).field_type,
    };
  }

  render() {
    const { item, index, fields, recomputeRowHeights } = this.props;
    const { field_type } = this.state;

    // only include a border for the last item
    const borderBottom = index === fields.length - 1 ? '1px solid #e7e7e7' : 'none';

    return (
      <Draggable key={item} draggableId={item} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={provided.draggableProps.style}
          >
            <div className="row">
              <Card style={{ ...styles.itemCard, borderBottom }}>
                <CardText style={{ padding: '17px 5px 0' }}>
                  <div className="row">
                    <div className="col-xs-1" style={{ padding: '27px 15px 0px' }}>
                      <span>
                        <DragIcon width={30} height={30} style={{ paddingTop: '8px' }} />
                      </span>
                    </div>
                    <div className="col-xs-9">
                      <div className="row">
                        <div className="col-xs-12">
                          <Field
                            name={`${item}.object`}
                            component={TextField}
                            floatingLabelText="Inspection Item"
                            validate={required}
                            style={{ fontSize: '14px', marginTop: '-22px', marginBottom: 10 }}
                            fullWidth
                          />
                        </div>
                        <div className="col-xs-6">
                          <label style={styles.labelText}>
                            Field Type
                            <Field
                              name={`${item}.field_type`}
                              validate={required}
                              style={{ fontSize: '14px', marginTop: '-22px', marginBottom: 10 }}
                              floatingLabelText="Field Type"
                              fullWidth
                              component={({ input: { onChange, value } }) => {
                                return (
                                  <Select
                                    value={value}
                                    onChange={(field_type) => {
                                      this.setState({ field_type });
                                      onChange(field_type);
                                    }}
                                  >
                                    <Select.Option value="condition">Condition</Select.Option>
                                    <Select.Option value="yes_no">Yes/No</Select.Option>
                                    <Select.Option value="free_form">Free Form</Select.Option>
                                    <Select.Option value="custom_options">Custom</Select.Option>
                                  </Select>
                                );
                              }}
                            />
                          </label>
                        </div>
                        <div className="col-xs-6">
                          <Field
                            name={`${item}.repair_cost`}
                            component={TextField}
                            floatingLabelText="Repair Cost"
                            style={{ fontSize: '14px', marginTop: '-22px', marginBottom: 10 }}
                            {...currencyMask}
                            fullWidth
                          />
                        </div>
                        {field_type === 'custom_options' && (
                          <div className="col-xs-12">
                            <label style={styles.labelText}>
                              Custom Options
                              <Field
                                name={`${item}.custom_options`}
                                component={({ input: { onChange, value } }) => (
                                  <Select
                                    mode="tags"
                                    placeholder="Select or type your options"
                                    value={value || undefined}
                                    onChange={onChange}
                                  >
                                    <Select.Option value="Good">Good</Select.Option>
                                    <Select.Option value="Repair">Repair</Select.Option>
                                    <Select.Option value="Replace">Replace</Select.Option>
                                    <Select.Option value="Damaged">Damaged</Select.Option>
                                    <Select.Option value="Wear and Tear">
                                      Wear and Tear
                                    </Select.Option>
                                  </Select>
                                )}
                              />
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="row" style={{ marginTop: 20 }}>
                        <div className="col-xs-12">
                          <Field
                            name={`${item}.photo_required`}
                            type="toggle"
                            component={Toggle}
                            label="Photo required"
                          />
                        </div>
                        {field_type !== 'free_form' && (
                          <div className="col-xs-12">
                            <Field
                              name={`${item}.comments_required`}
                              type="toggle"
                              component={Toggle}
                              label="Comments required"
                            />
                          </div>
                        )}
                        {field_type !== 'free_form' && (
                          <div className="col-xs-12">
                            <Field
                              name={`${item}.enable_na_response`}
                              type="toggle"
                              component={Toggle}
                              label="Enable N/A response"
                            />
                          </div>
                        )}
                        <div className="col-xs-12">
                          <Field
                            name={`${item}.show_create_service_request`}
                            type="toggle"
                            component={Toggle}
                            label="Show Create Service Request"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-2" style={{ textAlign: 'center' }}>
                      <IconButton
                        style={{
                          verticalAlign: 'top',
                          paddingLeft: '0',
                          width: '30px',
                        }}
                        onClick={() => {
                          fields.remove(index);
                          recomputeRowHeights();
                        }}
                      >
                        <DeleteIcon size={24} style={{ padding: 0 }} />
                      </IconButton>
                    </div>
                  </div>
                </CardText>
              </Card>
            </div>
          </div>
        )}
      </Draggable>
    );
  }
}

class InspectionItems extends React.Component {
  onDragEnd = ({ source, destination }) => {
    if (!destination) return; // dropped outside of list

    this.props.fields.move(source.index, destination.index);
  };

  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, _snapshot) => (
            <div ref={provided.innerRef}>
              <CSSTransitionGroup
                transitionName="add_inspection_item"
                transitionEnterTimeout={200}
                transitionLeaveTimeout={200}
              >
                {this.props.fields.map((item, index) => (
                  <InspectionItem
                    key={index}
                    item={item}
                    index={index}
                    fields={this.props.fields}
                    recomputeRowHeights={() => this.props.recomputeRowHeights(this.props.roomIndex)}
                  />
                ))}
              </CSSTransitionGroup>
            </div>
          )}
        </Droppable>

        <FlatButton
          label="Add Additional Item"
          type="button"
          backgroundColor="white"
          hoverColor="grey"
          style={{
            color: AccentColor(),
            margin: '15px auto 15px auto',
            display: 'block',
            backgroundColor: colors.LIGHTEST_GRAY,
          }}
          onClick={() => {
            this.props.fields.push({ field_type: 'condition' });
            this.props.recomputeRowHeights(this.props.roomIndex);
          }}
        />
      </DragDropContext>
    );
  }
}

class InspectionRooms extends React.Component {
  constructor(props) {
    super(props);
    this.list = React.createRef();
  }

  _renderRoom = ({ index, key, style }) => {
    const { fields } = this.props;
    const room = `${fields.name}[${index}]`;

    return (
      <div style={style}>
        <TransactionCard key={key} style={styles.transactionCard}>
          <Header name={`INSPECTION AREA ${index + 1}`} />
          <div className="row" style={{ padding: '15px 0 5px 15px' }}>
            <div className="col-xs-9">
              <Field
                name={`${room}.name`}
                component={TextField}
                hintText="Inspection Area"
                floatingLabelText="Inspection Area"
                validate={required}
                style={{ margin: '0px', fontFamily: 'Circular-Black', marginTop: '-23px' }}
                fullWidth
              />
            </div>
          </div>

          <div className="row" style={{ padding: '0 30px' }}>
            <FieldArray
              name={`${room}.inspects`}
              component={InspectionItems}
              recomputeRowHeights={this.recomputeRowHeights}
              roomIndex={index}
            />
          </div>
        </TransactionCard>
      </div>
    );
  };

  // The row height of an inspection room must be computed ahead of time. 85*numItems + a fixed amount
  _rowHeight = ({ index }) => {
    const inspects = this.props.fields.get(index)['inspects'];
    return inspects.reduce((acc, curr) => {
      if (curr['field_type'] === 'custom_options') {
        // custom_options fields are taller than others
        return acc + 350;
      } else {
        return acc + 300;
      }
    }, 31 + 69 + 31 + 20 + 66 + 25);
  };

  recomputeRowHeights = (index) => {
    // timeout needed to ensure we calculate row height after new field has been pushed
    setTimeout(() => this.list.current.recomputeRowHeights(index), 5);
  };

  render() {
    const { fields } = this.props;
    return (
      <AutoSizer>
        {({ height, width }) => (
          <List
            height={height}
            rowCount={fields.length}
            rowHeight={this._rowHeight}
            rowRenderer={this._renderRoom}
            width={width}
            overscanRowCount={3}
            ref={this.list}
          />
        )}
      </AutoSizer>
    );
  }
}

export default reduxForm({
  destroyOnUnmount: false,
  validate,
})((props) => (
  <form onSubmit={props.handleSubmit} style={{ height: 'calc(100% - 41px)' }}>
    <Field component={RenderError} name="details_page_errors" />
    <FieldArray name="inspection_rooms" component={InspectionRooms} values={props.values} />
    <div style={{ height: '150px' }} />
  </form>
));
